import { render, staticRenderFns } from "./capacityOrFlowApply.vue?vue&type=template&id=b71f8b00&scoped=true"
import script from "./capacityOrFlowApply.vue?vue&type=script&lang=js"
export * from "./capacityOrFlowApply.vue?vue&type=script&lang=js"
import style0 from "./capacityOrFlowApply.vue?vue&type=style&index=0&id=b71f8b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f8b00",
  null
  
)

export default component.exports